/* Take in two sets of Unlocks and return the newly added ones */
export function compareUnlocksStates(oldUnlocks, newUnlocks) {
  const wasCompleted = getCompletedUnlockKeys(oldUnlocks);
  const nowCompleted = getCompletedUnlockKeys(newUnlocks);

  //Return an array with only the NEW UNLOCK KEYS included.
  return nowCompleted.filter(unlockedKey => {
    return !wasCompleted.includes(unlockedKey); //Filter out entries that are seen in wasCompleted
  });
}

function getCompletedUnlockKeys(unlocksObj) {
  return Object.keys(unlocksObj).filter(key => {
    const model = unlocksObj[key];
    return model.isComplete;
  });
}



// WEBPACK FOOTER //
// ./src/b5-unlocks/compareUnlocksStates.js